"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var loadScript_1 = __importDefault(require("../loadScript"));
var useExternalScript = function (src, evaluate) {
    var _a = react_1.useState(false), isReady = _a[0], setIsReady = _a[1];
    var _b = react_1.useState(''), error = _b[0], setError = _b[1];
    var _c = react_1.useState(undefined), value = _c[0], setValue = _c[1];
    var successFnRef = react_1.useRef(function () { });
    react_1.useEffect(function () {
        successFnRef.current = function () {
            setTimeout(function () {
                setIsReady(true);
                setError('');
            }, 100);
        };
        loadScript_1.default(src, evaluate)
            .then(function () {
            setValue(evaluate);
            successFnRef.current();
        })
            .catch(function () {
            setError("Load failed for " + src);
        });
        return function () {
            successFnRef.current = function () { };
        };
    }, [src, evaluate]);
    return [isReady, error, value];
};
exports.default = useExternalScript;
